import { handleActions } from "redux-actions";

export const ActionTypes = {
    GET_ALL_GOERS_REQUEST: 'GET_ALL_GOERS_REQUEST',
    GET_ALL_GOERS_SUCCESS: 'GET_ALL_GOERS_SUCCESS',
    GET_ALL_GOERS_ERROR: 'GET_ALL_GOERS_ERROR'
}

const partyActions = {
    getAllPartyGoersRequestActionCreator: () => ({
        type: ActionTypes.GET_ALL_GOERS_REQUEST
    }),
    getAllPartyGoersSuccessActionCreator: (developers) => ({
        type: ActionTypes.GET_ALL_GOERS_SUCCESS,
        developers
    }),
    getAllPartyGoersErrorActionCreator: (error) => ({
        type: ActionTypes.GET_ALL_GOERS_ERROR,
        error
    }),
    reducer: handleActions({
        [ActionTypes.GET_ALL_GOERS_REQUEST]: (state) => ({state}),
        [ActionTypes.GET_ALL_GOERS_SUCCESS]: (state, action) => ({
            ...state,
            developers: action.developers
        }),
        [ActionTypes.GET_ALL_GOERS_ERROR]: (state, action) => ({
            ...state,
            error: action.error
        })
    },{
        //initial state
        partyGoers: [],
        error: null
    })
}

export default partyActions;